import React from 'react';
import { SIDEBAR_TYPE, SideNavGroup } from '@amzn/aac-chrome-internal-api';
import { ConnectedToolbarIcon } from './ToolbarIcon';
import { IconMarginWrapper } from './styles';
import SideNav from '../SideNav/SideNav';
import { connect } from 'react-redux';
import { updateActiveCategory } from '../../store/slice';

interface RegularIconProps {
  id: string;
  iconPath: string;
  toolTip: string;
  sidebarGroups: Array<SideNavGroup>;
  activeCategory: string;
  sidebarType?: SIDEBAR_TYPE;
  updateActiveCategory: (...args: any[]) => any;
}

const RegularIcon: React.VFC<RegularIconProps> = ({
  id,
  iconPath,
  toolTip,
  sidebarGroups,
  activeCategory,
  sidebarType,
  updateActiveCategory,
}) => {
  const isSelected = sidebarGroups.some((group) =>
    group.links.some((link) => link.isSelected),
  );

  const isSingleSidebar =
    sidebarGroups.length == 1 && sidebarGroups[0].links.length == 1;

  return (
    <>
      <IconMarginWrapper
        onFocus={() => {
          if (id !== activeCategory) updateActiveCategory('');
        }}
      >
        <ConnectedToolbarIcon
          id={id}
          iconPath={iconPath}
          toolTip={
            isSingleSidebar ? sidebarGroups[0].links[0].link.label : toolTip
          }
          isSelected={isSelected}
          isSingleSidebar={isSingleSidebar}
          singleSidebarApp={sidebarGroups[0].links[0]}
          activeCategory={activeCategory}
        />
      </IconMarginWrapper>
      {!isSingleSidebar && (
        <SideNav
          sidebarGroups={sidebarGroups}
          toolbarItemId={id}
          sidebarTitle={toolTip}
          sidebarType={sidebarType}
          activeCategory={activeCategory}
          updateActiveCategory={updateActiveCategory}
        />
      )}
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateActiveCategory: (category) =>
      dispatch(updateActiveCategory(category)),
  };
};

export default connect(null, mapDispatchToProps)(RegularIcon);
